import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";

import { ReactComponent as Logo } from "../../assets/images/Logo.svg";

import LinkTab from "../LinkTab";

export const NavWrapper = styled("div")(({ theme }) => {
  return {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    boxShadow: "0px 1px 2px rgba(51, 51, 51, 0.1);",
    backgroundColor: theme.palette.grayScale.white,
  };
});

export const Nav = styled("nav")(() => ({
  marginTop: "17px",
}));

export const StyledLink = styled(Link)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  color: theme.palette.institutional.braskemGray,
  textDecoration: "none",
  fontWeight: 700,
  margin: theme.spacing(3),
  h6: {
    marginLeft: "24px",
  },
  userEmail: {
    fontWeight: "bold",
  },
}));

export const StyledLinkTab = styled(LinkTab)(() => ({
  textTransform: "none",
  fontWeight: "bold",
}));



export const StyledLogo = styled(Logo)({
  marginBottom: "3px",
  marginRight: "16px",
});

export const ApplicationTitle = styled(Typography)(({theme}) => ({
  color: theme.palette.institutional.braskemGray
}));

export const AccountMenuWrapper = styled("div")(({ theme }) => ({
  margin: theme.spacing(3),
}));
